<template>
    <main class="cart-page default">
        <div class="container" v-if="cart != null">
            <div class="row">


                <div class="cart-page-content col-xl-9 col-lg-12 col-md-12 order-1">

                    <div style="position:relative" class="table-responsive-y checkout-content default">

                        <table class="table">
                            <div class="loader" style="display:none;position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:10;width:100%;height:100%;"><img style="position:absolute;top:35%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
                            <tbody>
                                <tr :class="['checkout-item','tr-DiscountPercent']" v-for="(detail,index) in cart.CartInfo.CartDetails">
                                    <td class="td-img">
                                        <router-link :to="{ name: 'product' , params: { productId: detail.ProductId , productName: detail.ProductName.replace(/\s+/g, '-') }}"><img :src="detail.ProductPicPath" alt="" @error="imageLoadOnError"></router-link>
                                        <button @click="removeItem(detail.ProductSaleParamId)" class="checkout-btn-remove"></button>
                                    </td>
                                    <td width="350">

                                        <div>
                                            <h3 class="checkout-title">
                                                <router-link :to="{ name: 'product' , params: { productId: detail.ProductId , productName: detail.ProductName.replace(/\s+/g, '-') }}">{{ detail.ProductName }}</router-link> <br />  <span class="code-kala"> کد کالا : {{ detail.ProductId }}</span>
                                            </h3>
                                        </div>
                                        <div v-if="detail.IsAvalible != true" class="update-e">
                                            <span class="unavailable">ناموجود ( تعداد موجودی  {{detail.StockInventory}} کالا )</span>
                                            <div class="re-itme-d">
                                                <i class="btn-g-s" @click="BatchUpdateQuantity()">بروزرسانی تعداد</i>
                                            </div>
                                        </div>
                                        <div v-if="detail.IsEnableCartComment" class="comment-cart">
                                            <textarea rows="2" class="input-field" v-model="detail.Comment" type="text" placeholder="توضیحات خود را وارد نمایید"></textarea>
                                        </div>


                                    </td>
                                    <td width="150" class="td-cart-box-counter">
                                        <div class="cart-box-counter">
                                            <div class="re-itme-d">
                                                <i class="incress now-ui-icons ui-1_simple-add " @click="UpdateQuantity(detail.ProductSaleParamId , ++detail.Quantity)"></i>
                                                <!--<i class="btn-g-s" @click="UpdateQuantity(detail.ProductSaleParamId , detail.Quantity)">ثبت</i>-->
                                                <input class="input-qu" @change="UpdateQuantity(detail.ProductSaleParamId , detail.Quantity)" type="text" v-model="detail.Quantity" />
                                                <i class="decress now-ui-icons ui-1_simple-delete" @click="UpdateQuantity(detail.ProductSaleParamId , --detail.Quantity)"></i>
                                                <!--<i class="decress now-ui-icons ui-1_simple-delete" @click="Decrease(detail.ProductSaleParamId)"></i>-->
                                            </div>

                                        </div>
                                    </td>
                                    <td class="td-cart-box-price">
                                        <div v-if="cart.CartInfo.CustomerGroupId == 2 && detail.IsShowColleagueChequePrice" class="cart-box-price">
                                            <div class="shopping-page">
                                                <div class="radio">
                                                    <input @change="changePaymentType($event , detail.ProductSaleParamId , detail.Quantity)" type="radio" :name="'radio' + index" :id="'carrier' + index" value="2" :checked="detail.PaymentTypeId == 2 && detail.IsShowColleagueChequePrice">
                                                    <label :for="'carrier' + index">
                                                        <span class="carrierName"> چک </span>
                                                    </label>
                                                </div>
                                                <div class="">
                                                    <div class="discount-detail" v-if="detail.DiscountPercent > 0">
                                                        <div class="line-price">
                                                            <span class="detsail-Price">
                                                               محاسبه نشده
                                                            </span>
                                                            <span class="txd-toman">تومان</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span class="finalPrice">
                                                           محاسبه نشده
                                                        </span>
                                                        <span class="tsd-toman">تومان</span>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <hr class="w-100" v-if="cart.CartInfo.CustomerGroupId == 2 && detail.IsShowColleagueChequePrice" />
                                        <div v-if="cart.CartInfo.CustomerGroupId != 2 ">
                                            <label>
                                                <span class="carrierName"> قیمت </span>
                                            </label>
                                        </div>
                                        <div class="cart-box-price">

                                            <div class="shopping-page">
                                                <div  v-if="cart.CartInfo.CustomerGroupId == 2" class="radio">
                                                    <div style="display:none">
                                                        <input @change="changePaymentType($event , detail.ProductSaleParamId , detail.Quantity )" type="radio" :name="'radio' + index" :id="'carrier_' + index" value="1" :checked=" detail.PaymentTypeId == 1 ">
                                                        <label :for="'carrier_' + index">
                                                            <span class="carrierName"> نقدی </span>
                                                        </label>
                                                    </div>
                                                </div>



                                                <div class=" ">
                                                    <div :style='{top:cart.CartInfo.CustomerGroupId != 2 ? "-12px" : ""}' class="discount-detail" v-if="detail.DiscountPercent > 0">
                                                        <div class="line-price">
                                                            <span class="detsail-Price">
                                                            محاسبه نشده
                                                            </span>
                                                            <!--<span class="txd-toman">تومان</span>-->
                                                        </div>

                                                    </div>
                                                    <div>
                                                        <span class="finalPrice">
                                                            محاسبه نشده
                                                        </span>
                                                        <!--<span class="tsd-toman">تومان</span>-->
                                                    </div>
                                                </div>


                                            </div>
                                        </div>


                                    </td>

                                    <td class="td-cart-box-price">
                                        <div class="cart-box-price m-l-25">
                                            <div>
                                                <div class="radio">
                                                    <span class="carrierName font-weight-bold"> جمع کل </span>
                                                </div>
                                                <div>
                                                    <span class="finalPrice">
                                                        محاسبه نشده
                                                    </span>
                                                  
                                                </div>

                                            </div>
                                        </div>
                                    </td>

                                    
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
                <aside class="cart-page-aside col-xl-3 col-lg-4 col-md-6 center-section order-2">
                    <div class="checkout-aside">
                        <div class="checkout-summary">
                            <div class="loader" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%;display:none"><img style="position:absolute;top:35%;left:39%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
                            <cart-summary></cart-summary>
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    </main>
</template>

<script>
    import { batchUpdateQuantity } from "../../module/cart";
    import { setCart } from "../../module/cart";
    import cartSummary from "./cartSummary.vue";
    export default {
        data() {
            return { showLoader: false, redirectBtnName: '', }
        },
        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            }, baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            },
        },
        components: {
            'cart-summary': cartSummary,
        },
        methods: {
            changePaymentType(event, productSaleParamId, quantity) {
                this.UpdatePaymentType(productSaleParamId, event.target.value, quantity);
            },
            handleClick() {
                return false;
            },
            redirectToPage() {
                switch (this.$route.path) {
                    case '/chooseAddress':
                        this.$router.push('/cart');
                        break;
                    case '/invoice':
                        this.$router.push('/cart');
                        break;
                    case '/cart':
                        this.$router.push('/chooseAddress');
                        break;
                }
            },
            removeItem(productSaleParamId) {

                setCart(this, productSaleParamId, 'RemoveItem', '.loader');
            },
            Increase(productSaleParamId) {
                setCart(this, productSaleParamId, 'Increase', '.loader');
            },
            Decrease(productSaleParamId) {
                setCart(this, productSaleParamId, 'Decrease', '.loader');
            },
            UpdatePaymentType(productSaleParamId, updatePaymentType, quantity) {
                setCart(this, productSaleParamId, 'UpdatePaymentType', '.loader', updatePaymentType, quantity);
            },
            UpdateQuantity(productSaleParamId, quantity) {

                this.cart.CartInfo.CartDetails.filter(c => c.ProductSaleParamId === productSaleParamId)[0].Quantity = quantity;
                var data = [];
                for (var i = 0; i < this.cart.CartInfo.CartDetails.length; i++) {
                    data.push({ Comment: this.cart.CartInfo.CartDetails[i].Comment , ProductSaleParamId: this.cart.CartInfo.CartDetails[i].ProductSaleParamId, Quantity: this.cart.CartInfo.CartDetails[i].Quantity, HashCartId: localStorage.getItem("CartHashId") });
                }
                batchUpdateQuantity(this, '.loader', data);

            },
            BatchUpdateQuantity() {
                var data = [];
                for (var i = 0; i < this.cart.CartInfo.CartDetails.length; i++) {
                    if (this.cart.CartInfo.CartDetails[i].StockInventory > 0 && !this.cart.CartInfo.CartDetails[i].IsAvalible)
                        data.push({ Comment: this.cart.CartInfo.CartDetails[i].Comment ,  ProductSaleParamId: this.cart.CartInfo.CartDetails[i].ProductSaleParamId, Quantity: this.cart.CartInfo.CartDetails[i].StockInventory, HashCartId: localStorage.getItem("CartHashId") });
                }
                batchUpdateQuantity(this, '.loader', data);
            },
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },

        },

        beforeMount: function () {
            if (this.$route.path == '/cart') {
                this.redirectBtnName = 'ادامه ثبت سفارش';
            }
            if (this.$route.path == '/chooseAddress') {
                this.redirectBtnName = 'ویرایش سبد خرید';
            }
            if (this.$route.path == '/invoice') {
                this.redirectBtnName = 'ویرایش سبد خرید';
            }

        }
    }
</script>

<style scoped>
    .comment-cart .input-field {
        padding: 11px 15px 11px 11px;
    }
        .comment-cart {
        padding: 10px;
    }

    .update-e {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

        .update-e .re-itme-d {
            margin-top: 15px;
        }

            .update-e .re-itme-d .btn-g-s {
                padding: 4px 7px 4px 7px;
                font-size: 13px;
            }

    .btn-g-s {
        background-color: #aae67c;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 5px;
        color: #fff;
    }

        .btn-g-s:hover {
            cursor: pointer;
        }

    .input-qu {
        width: 45px;
        margin-left: 5px;
        margin-right: 5px;
        border-radius: 5px;
        background: #fff;
        border: 1px solid #c8c8c8;
        color: #717171;
        font-size: 14px;
        line-height: 1.571;
        text-align: center;
    }

    .tr-DiscountPercent {
        position: relative;
    }

    .dd-percent {
        position: absolute;
        left: 5px;
        top: 5px;
        width: 40px;
        height: 20px;
        color: #fff;
        background-color: #e46161;
        display: flex;
        justify-content: center;
        align-items: center;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-top-right-radius: 15px;
        border-bottom-left-radius: 5px;
    }

    .shopping-page .radio label::before, .shopping-page .radio label::after {
        right: 15px;
    }

    .shopping-page .radio input[type="radio"]:checked + label::after {
        right: 18px;
    }

    .radio {
        margin-bottom: 2px;
    }

    .td-cart-box-price {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .mgf-d {
        margin-top: 15px;
    }

    .td-cart-box-price .cart-box-price .discount-detail {
        font-size: 12px;
        top: 20px;
        left: 0px;
    }

    .checkout-item {
        flex-flow: row wrap;
    }

        .checkout-item .td-img img {
            width: 150px;
        }

    .td-cart-box-price .cart-box-price {
        position: relative;
    }

    .checkout-item {
        width: 100%;
        display: flex;
        text-align: center;
        overflow: hidden;
        justify-content: space-between;
        align-items: center;
    }

    .cart-page-title-btn {
        margin: 15px 0 0;
        background-color: #fff;
        border-radius: 7px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

        .cart-page-title-btn .btn {
            color: #fff;
            margin: 10px;
            padding: 8px 11px;
            font-size: 14px;
        }

        .cart-page-title-btn .btn-f {
            background-color: #979797;
            color: #fff;
        }

            .cart-page-title-btn .btn-f:hover {
                background-color: #979797;
                color: #fff;
            }

        .cart-page-title-btn .btn:before {
            content: unset;
        }

    .code-kala {
        font-size: 12px;
        color: #9db09e;
    }

    .count-Item {
        display: block;
        width: 60px;
        /* margin-left: 10px;
        margin-right: 10px;*/
    }

    .cart-box-counter {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .cart-page-title-y {
        background-color: #fff;
        border-radius: 7px;
        padding-bottom: 15px;
        padding: 10px 15px 10px 15px;
    }

        .cart-page-title-y span {
            font-weight: bold;
            font-size: 16px;
        }

    .cart-page-title {
        background-color: #fff;
        border-radius: 7px;
        padding-bottom: 15px;
        padding: 3px 15px 3px 15px;
        margin: 15px 0 15px;
    }

        .cart-page-title span {
            color: #009ec9;
            font-size: 13px;
            display: inline-block;
            margin-bottom: 5px;
        }

    tbody {
        width: 100%;
        display: block;
    }

    @media screen and (max-width: 750px) {
        .checkout-item {
            width: 100%;
            overflow-x: visible;
            display: block;
        }

        tbody, thead {
            float: left;
            width: 100%;
        }

        thead {
            min-width: 120px;
            width: 100%;
        }

        td, th {
            display: block;
            width: 100%;
        }
    }

    .table {
        width: 100%;
        margin-bottom: unset;
        position: relative;
        display: inline-block;
    }

    .unavailable {
        padding: 3px 10px 3px 10px;
        border-radius: 10px;
        color: #fff;
        background-color: #e66363;
        display: inline-block;
    }

    .cart-page .checkout-aside {
        margin-bottom: 83px;
    }

    /* .td-cart-box-price {
        width: 27%;
    }*/

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .unavailable {
            font-size: 12px;
        }

        .m-l-25 {
            margin-left: 0;
        }
    }

    @media only screen and (min-width: 640px) and (max-width: 850px) {
    }
</style>